// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"83304170","664":"6265254a"}[chunkId] + ".chunk.js";
};